/**
 * Debounces given function that returns a promise. Lodash does not properly support this.
 */
export default (f, interval) => {
  let timer = null

  return (...args) => {
    clearTimeout(timer)

    return new Promise((resolve) => {
      timer = setTimeout(
        () => resolve(f(...args)),
        interval
      )
    })
  }
}
